/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GroundingServiceResponseError = {
    Unknown: 'Unknown',
    MissingGroundingData: 'MissingGroundingData',
    TimeOut: 'TimeOut',
    Aggregated: 'Aggregated'
} as const;
export type GroundingServiceResponseError = typeof GroundingServiceResponseError[keyof typeof GroundingServiceResponseError];


export function instanceOfGroundingServiceResponseError(value: any): boolean {
    for (const key in GroundingServiceResponseError) {
        if (Object.prototype.hasOwnProperty.call(GroundingServiceResponseError, key)) {
            if (GroundingServiceResponseError[key as keyof typeof GroundingServiceResponseError] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GroundingServiceResponseErrorFromJSON(json: any): GroundingServiceResponseError {
    return GroundingServiceResponseErrorFromJSONTyped(json, false);
}

export function GroundingServiceResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroundingServiceResponseError {
    return json as GroundingServiceResponseError;
}

export function GroundingServiceResponseErrorToJSON(value?: GroundingServiceResponseError | null): any {
    return value as any;
}

export function GroundingServiceResponseErrorToJSONTyped(value: any, ignoreDiscriminator: boolean): GroundingServiceResponseError {
    return value as GroundingServiceResponseError;
}

